import { Card as AntdCard, CardProps } from 'ant-design-vue'
import { defineComponent, h } from 'vue'

export const Card = defineComponent<CardProps>({
  name: 'Card',
  setup(props: CardProps, { slots }) {
    return () => h(AntdCard, { ...props }, slots)
  },
})

export default Card
